
(function() {
  var result = { translations: { "ar-eg": { "i18n": { "duration": { "seconds": "{{ seconds }} \u062B\u0627\u0646\u064A\u0629", "minutes": "{{ minutes }} \u062F\u0642\u064A\u0642\u0629", "hours": "{{ hours }} \u0633\u0627\u0639\u0629", "hoursAndMinutes": "{{ hours }} \u0633\u0627\u0639\u0629 {{ minutes }} \u062F\u0642\u064A\u0642\u0629", "days": "{{ days }} \u0623\u064A\u0627\u0645", "shortForm": { "seconds": "{{ seconds }} \u062B", "minutes": "{{ minutes }} \u062F", "hours": "{{ hours }} \u0633", "days": "{{ days }} \u064A", "hoursAndMinutes": "{{ hours }} \u0633 {{ minutes }} \u062F" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}\u060C \u062A\u0645\u062F\u064A\u062F {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ar-eg": "static-7.927"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.927",
    "ar-eg": "static-7.927",
    "bg": "static-7.927",
    "bn": "static-7.927",
    "ca-es": "static-7.927",
    "cs": "static-7.927",
    "da": "static-7.927",
    "de": "static-7.927",
    "el": "static-7.927",
    "en-gb": "static-7.927",
    "en": "static-7.927",
    "es-mx": "static-7.927",
    "es": "static-7.927",
    "fi": "static-7.927",
    "fr-ca": "static-7.927",
    "fr": "static-7.927",
    "he-il": "static-7.927",
    "hr": "static-7.927",
    "hu": "static-7.927",
    "id": "static-7.927",
    "it": "static-7.927",
    "ja": "static-7.927",
    "ko": "static-7.927",
    "lt": "static-7.927",
    "ms": "static-7.927",
    "nl": "static-7.927",
    "no": "static-7.927",
    "pl": "static-7.927",
    "pt-br": "static-7.927",
    "pt-pt": "static-7.927",
    "ro": "static-7.927",
    "ru": "static-7.927",
    "sk": "static-7.927",
    "sl": "static-7.927",
    "sv": "static-7.927",
    "th": "static-7.927",
    "tl": "static-7.927",
    "tr": "static-7.927",
    "uk": "static-7.927",
    "vi": "static-7.927",
    "x-pseudo": "static-7.927",
    "zh-cn": "static-7.927",
    "zh-hk": "static-7.927",
    "zh-tw": "static-7.927"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ar-eg', {version: 'static-7.927'}); }
})();


